import React from "react";
import { escape2Html } from "../../util";
import "../../style/index.less";

import { WeaTools, WeaLocaleProvider } from "ecCom";
const loadCss = WeaTools.loadCss;
const getLabel = WeaLocaleProvider.getLabel;
const { desensitization, encryption, Encry } = WeaTools.EncryBase;
class SingleMessage extends React.PureComponent {
  onSigleItemContentClick = () => {
    if (this.props.bodyLink) {
      if (window.em && window.localStorage.emobile_ec_id) {
        window.em.checkJsApi("openLink") &&
          window.em.openLink({
            url: this.props.link,
            openType: 2,
            sysId: window.localStorage.emobile_ec_id,
            error: function(error) {
              alert(JSON.stringify(error));
            }
          });
        !window.em.checkJsApi("openLink") && window.open(this.props.link);
      } else {
        window.open(this.props.link);
      }
    }
  };

  readDetail1 = () => {
    if (this.props.bodyLink) {
      return;
    }
    if (window.em && window.localStorage.emobile_ec_id) {
      window.em.checkJsApi("openLink") &&
        window.em.openLink({
          url: this.props.link,
          openType: 2,
          sysId: window.localStorage.emobile_ec_id,
          error: function(error) {
            alert(JSON.stringify(error));
          }
        });
      !window.em.checkJsApi("openLink") && window.open(this.props.link);
    } else {
      window.open(this.props.link);
    }
  };

  readDetail2 = () => {
    // eval(this.props.gomethodpc);
    const self = this;
    eventRegister.loadModule("f_smallApp", {}, function() {
      window.weaSmallApp.store.smsRadioStore.showMsgDialog(
        self.props.gomethodpc
      );
      self.props.updateSyncCom(window.weaSmallApp.com.RadioDialog);
      loadCss();
    });
  };

  renderBottom() {
    let bottomComponent = null;
    const isEmobile = window.navigator.userAgent.indexOf("E-Mobile") > -1;
    // openType:
    //   0 不显示
    //   1 新窗口
    //   2 弹窗
    let openType = 0;
    if (isEmobile) {
      if (this.props.link != "") {
        // Emobile 中打开: 新窗口
        openType = 1;
      }
    } else {
      if (this.props.gomethodpc) {
        // 浏览器 EM 中打开：弹窗
        // 浏览器消息中心打开： 弹窗
        openType = 2;
      } else if (this.props.link) {
        // 一般消息链接
        openType = 1;
      }
    }

    if (openType === 1) {
      bottomComponent = (
        <a
          // target="_blank"
          className="wea-messageCenter-singleItem-a"
          // href={`${this.props.link}`}
          onClick={this.readDetail1}
        >
          <div className="wea-messageCenter-singleItem-more wea-f12">
            {getLabel("503547", "阅读详情")}
            <span className="wea-messageCenter-singleItem-moreIcon">&gt;</span>
          </div>
        </a>
      );
    }
    if (openType === 2) {
      bottomComponent = (
        <a
          // target="_blank"
          className="wea-messageCenter-singleItem-a"
          // href={`${this.props.link}`}
          onClick={this.readDetail2}
        >
          <div className="wea-messageCenter-singleItem-more wea-f12">
            {getLabel("503547", "阅读详情")}
            <span className="wea-messageCenter-singleItem-moreIcon">&gt;</span>
          </div>
        </a>
      );
    }
    return bottomComponent;
  }

  renderTitle = () => {
    const { searchValue, title: name, showHighLight = false } = this.props;
    if (searchValue && name.indexOf(searchValue) >= 0 && showHighLight) {
      const resName = name.replace(
        searchValue,
        `<span class="wea-messageCenter-singleItem-detail-highlight">${searchValue}</span>`
      );
      if (desensitization(resName) || encryption(resName)) {
        return <Encry value={resName} />;
      }
      return <span dangerouslySetInnerHTML={{ __html: resName }} />;
    } else {
      if (desensitization(name) || encryption(name)) {
        return <Encry value={name} />;
      }
      return <span dangerouslySetInnerHTML={{ __html: name }} />;
    }
  };

  render() {
    const bizstateEnum = {
      "1": getLabel("1454", "已处理"),
      "34": getLabel("129265", "已暂停"),
      "35": getLabel("1981", "已撤销"),
      "27": getLabel("18967", "已删除")
    };
    return (
      <div className="wea-messageCenter-singleItem">
        <p className="wea-messageCenter-singleItem-time wea-f12">
          {this.props.time}
        </p>
        {this.props.showimage && (
          <div
            style={{ backgroundImage: `url(${this.props.showimage})` }}
            className="wea-messageCenter-singleItem-image"
          />
        )}
        <div
          className="wea-messageCenter-singleItem-content"
          onClick={this.onSigleItemContentClick}
        >
          <div className="wea-messageCenter-singleItem-title wea-f14">
            {" "}
            {desensitization(this.props.name) || encryption(this.props.name) ? (
              <Encry value={this.props.name} />
            ) : (
              this.props.name || ""
            )}
          </div>
          <div
            // title={escape2Html(this.props.title)}
            className="wea-messageCenter-singleItem-detail wea-f12"
          >
            {this.renderTitle()}
          </div>
          {this.props.context && (
            <div className="wea-messageCenter-singleItem-creator wea-f12">
              {desensitization(this.props.context) ||
              encryption(this.props.context) ? (
                <Encry value={this.props.context} />
              ) : (
                <p
                  dangerouslySetInnerHTML={{
                    __html: escape2Html(
                      this.props.context.replace(/<img[^>]+>/gi, "[图片]")
                    )
                  }}
                />
              )}
            </div>
          )}
          {this.props.bizstate !== "0" && this.props.bizStateName && (
            <div
              className="wea-messageCenter-singleItem-handled-tag"
              style={{ bottom: !this.props.link && "0" }}
            >
              <i>
                {desensitization(this.props.bizStateName) ||
                encryption(this.props.bizStateName) ? (
                  <Encry value={this.props.bizStateName} />
                ) : (
                  this.props.bizStateName || ""
                )}
              </i>
            </div>
          )}
          {this.props.bizstate !== "0" &&
            !this.props.bizStateName &&
            Object.keys(bizstateEnum).includes(this.props.bizstate) && (
              <div className="wea-messageCenter-singleItem-handled-tag">
                <i>
                  {desensitization(bizstateEnum[this.props.bizstate]) ||
                  encryption(bizstateEnum[this.props.bizstate]) ? (
                    <Encry value={bizstateEnum[this.props.bizstate]} />
                  ) : (
                    bizstateEnum[this.props.bizstate]
                  )}
                </i>
              </div>
            )}
          {this.renderBottom()}
        </div>
      </div>
    );
  }
}
export default SingleMessage;



// WEBPACK FOOTER //
// ./comMobx/wea-message-center/components/message-center/singleMessage.js